<template>
  <div>
    <Navbar></Navbar>
    <SearchProducts></SearchProducts>
  </div>
</template>

<script>
import Navbar from "../components/Navbar.vue";
import SearchProducts from "../components/ListProductsFromSearch.vue";
export default {
  methods: {},
  components: {
    Navbar,
    SearchProducts
  }
};
</script>

<style>
</style>